module.exports = __webpack_public_path__ + "fonts/sms_ico@2x.22ff7b1f3885317f73f81e0e534966aa.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/sms_ico@2x.png
// module id = 764
// module chunks = 9